export const maximumTaskSupportUsers = 3

export function normalizeTaskSupportUsers(value: unknown, owner = '') {
  if (!Array.isArray(value)) return []
  return [...new Set(value.filter((user): user is string => typeof user === 'string' && Boolean(user) && user !== owner))]
    .slice(0, maximumTaskSupportUsers)
}

export function canManageTaskSupport(canAssignOwner: boolean, createdBy: string, owner: string, currentUser: string) {
  return canAssignOwner || createdBy === currentUser || owner === currentUser
}
